(function () {
  // Keep track of instances per section element
  var registry = new Map();

  function jsonish(value, fallback) {
    if (value == null) return fallback;
    var v = String(value).trim();
    if (!v) return fallback;
    try { return JSON.parse(v); } catch (e) { return v; } // supports '">1"'
  }

  function cssVar(el, name, fallback) {
    var v = getComputedStyle(el).getPropertyValue(name).trim();
    return v ? v : fallback;
  }

  function findSettingsFor(sectionEl) {
    // section id = DP--<id>, your JSON has data-spc="<id>"
    var rawId = sectionEl.id.replace(/^DP--/, '');
    var node =
      document.querySelector('script[type="application/json"][data-spc="' + rawId + '"]') ||
      sectionEl.querySelector('script[type="application/json"][data-spc]');
    var base = { id: rawId, autoplay: 0 };
    if (!node) return base;
    try { return Object.assign(base, JSON.parse(node.textContent || node.innerHTML)); }
    catch (_) { return base; }
  }

  function initOne(sectionEl) {
    if (!sectionEl || registry.has(sectionEl)) return;

    var settings = findSettingsFor(sectionEl);
    var slider =
      sectionEl.querySelector('#slider-' + settings.id) ||
      sectionEl.querySelector('.spc__videos-wrapper');
    if (!slider) return;

    // Pull per-section options from your existing CSS vars
    var draggable = jsonish(cssVar(sectionEl, '--draggable', 'true'), true);
    var wrapAround = jsonish(cssVar(sectionEl, '--wrap-around', 'false'), false);

    var flkty = new Flickity(slider, {
      cellAlign: 'left',
      autoPlay: settings.autoplay,                 // from your JSON
      draggable: draggable,                        // from --draggable (supports true/false or ">1")
      contain: true,
      wrapAround: wrapAround,                      // from --wrap-around
      adaptiveHeight: false,
      watchCSS: false,
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: false,
      on: {
        staticClick: function (event, pointer, cellElement, cellIndex) {
          if (typeof cellIndex === 'number') this.selectCell(cellIndex);
        },
        ready: function () {
          setTimeout(function () {
            slider.classList.add('spc__stretch-height');
          }, 500);
        }
      }
    });

    // Match your "switch to center after first interaction" behavior
    var alignedLeft = true;
    function switchToCenter() {
      if (!alignedLeft) return;
      flkty.options.cellAlign = 'center';
      flkty.reloadCells();
      flkty.resize();
      alignedLeft = false;
    }
    slider.addEventListener('mousedown', switchToCenter);
    slider.addEventListener('touchstart', switchToCenter, { passive: true });

    // Optional arrows (only if that markup is rendered)
    var prevBtn = sectionEl.querySelector('.spc__nav-button--prev');
    if (prevBtn) prevBtn.addEventListener('click', function () {
      switchToCenter();
      flkty.previous();
    });
    var nextBtn = sectionEl.querySelector('.spc__nav-button--next');
    if (nextBtn) nextBtn.addEventListener('click', function () {
      switchToCenter();
      flkty.next();
    });

    registry.set(sectionEl, { flkty: flkty });
  }

  function destroyOne(sectionEl) {
    var rec = registry.get(sectionEl);
    if (!rec) return;
    try { rec.flkty.destroy(); } catch (_) {}
    registry.delete(sectionEl);
  }

  function initAll(root) {
    // Your inner section element is <section id="DP--{{ section_id }}">
    (root || document).querySelectorAll('section[id^="DP--"]').forEach(initOne);
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  // Theme editor events
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    // e.target is the outer wrapper; try to find your inner <section id="DP--…">
    var inner = e.target.querySelector('section[id^="DP--"]') || e.target;
    destroyOne(inner);
  });
  document.addEventListener('shopify:section:reorder', function (e) {
    initAll(e.target);
  });
})();
